import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Loader.css';

class TextLoader extends React.Component {

    static propTypes = {
        loadingText: PropTypes.string,
    };

    render() {
        const { loadingText, loadingTextSize } = this.props;
        return (
            <div className={s.loadingTextContainer}>
                <p>
                    {loadingText && <span>{loadingText}</span>}
                    <span className={s.loadingTextWrapper}>
                        <span className={s.loadingTextSpan} />
                        <span className={s.loadingTextSpan} />
                        <span className={s.loadingTextSpan} />
                    </span>
                </p>
            </div>
        );
    }
}

export default withStyles(s)(TextLoader);